import { render, staticRenderFns } from "./EventRegisterInterest.vue?vue&type=template&id=0f067a6c&"
import script from "./EventRegisterInterest.vue?vue&type=script&lang=js&"
export * from "./EventRegisterInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports